(function() {
  if (window._variantSwitcherInit) return;
  window._variantSwitcherInit = true;

  function formatMoney(cents, currency) {
    if (!cents) return '';
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + amount + ' ' + (currency || 'USD');
  }

  document.addEventListener('mouseover', function(e) {
    var pill = e.target.closest('.card-variant__pill');
    if (!pill) return;
    var container = pill.closest('.card-variants');
    var card = pill.closest('.card-wrapper');
    if (!container || !card) return;

    // Add class to suppress the card quick-add overlay
    card.classList.add('variant-pill-hover');

    // Highlight only this pill
    container.querySelectorAll('.card-variant__pill').forEach(function(p) {
      p.classList.remove('active');
    });
    pill.classList.add('active');

    // Swap image if this variant has its own image
    var imgSrc = pill.dataset.variantImage;
    if (imgSrc) {
      var img = card.querySelector('.card__media img.motion-reduce');
      if (img) {
        if (!img.dataset.originalSrc) img.dataset.originalSrc = img.src;
        img.src = imgSrc;
      }
    }

    // Swap sale price
    var priceCents = pill.dataset.variantPrice;
    var currency = pill.dataset.variantCurrency || 'USD';
    if (priceCents) {
      var salePriceEl = card.querySelector('.price-item--sale .money') || card.querySelector('.price-item--sale');
      if (salePriceEl) {
        if (!salePriceEl.dataset.originalPrice) salePriceEl.dataset.originalPrice = salePriceEl.textContent;
        salePriceEl.textContent = formatMoney(priceCents, currency);
      }
      var comparePriceCents = pill.dataset.variantComparePrice;
      var comparePriceEl = card.querySelector('.price__sale .price-item--regular .money');
      if (comparePriceEl) {
        if (!comparePriceEl.dataset.originalPrice) comparePriceEl.dataset.originalPrice = comparePriceEl.textContent;
        comparePriceEl.textContent = comparePriceCents
          ? formatMoney(comparePriceCents, currency)
          : (comparePriceEl.dataset.originalPrice || '');
      }
    }
  });

  // Remove the suppression class when mouse leaves the pill area
  document.addEventListener('mouseout', function(e) {
    var pill = e.target.closest('.card-variant__pill');
    if (!pill) return;
    var card = pill.closest('.card-wrapper');
    if (!card) return;
    // Only remove if not entering another pill in same card
    var related = e.relatedTarget;
    if (!related || !related.closest || !related.closest('.card-variants')) {
      card.classList.remove('variant-pill-hover');
    }
  });
})();